import MutationService from '../services/MutationService';
import CurrencyService from '../services/CurrencyService';
import container from '../services/Container';
import { EXTERNAL_URL_MAP, ESHOP_HOMEPAGE_MAP } from '../parameters';

export default class RouteHelper {

	/**
	 * @return {string}
	 */
	static getAllowedMutations() {
		return container.state.mutations.items.map(m => m.code).join('|');
	}

	/**
	 * @param {?string} prefix
	 * @return {string}
	 */
	static getAllowedCurrencies(prefix = '') {
		return container.state.currencies.items.map(c => prefix + c.getCodeForUrl()).join('|');
	}

	/**
	 * @param {string} url
	 * @param mutationCode
	 * @param currencyCode
	 * @return {string|*}
	 */
	static getUrl(url, mutationCode, currencyCode) {
		let prefix = RouteHelper.getMutationAsRouteParam(mutationCode, currencyCode) + RouteHelper.getCurrencyAsRouteParam(currencyCode);
		let regexp = '^/(' + RouteHelper.getAllowedMutations() + ')(' + RouteHelper.getAllowedCurrencies('-') + ')?/';
		url = url.replace(new RegExp(regexp), '/');
		if (prefix.length > 0) {
			prefix = '/' + prefix;
		}
		url = prefix + url;
		if (url.length === 0 || url[0] !== '/') {
			url = '/' + url;
		}
		return url;
	}

	/**
	 * @param {string} url
	 * @return {string|*}
	 */
	static getExternalUrl(url) {
		const externalUrl = EXTERNAL_URL_MAP[url];
		return externalUrl ? externalUrl : '/';
	}

	/**
	 * @param {number} id
	 * @return {string|*}
	 */
	static getExternalUrlByShopId(id) {
		return  ESHOP_HOMEPAGE_MAP[id] || ESHOP_HOMEPAGE_MAP[12];
	}

	/**
	 * This will perform redirect if we have superfluous currency or mutation in our route
	 *
	 * @param {object} location
	 * @param {string} mutation
	 * @param {string} currency
	 * @return {boolean|string}
	 */
	static checkForRedirects(location, mutation, currency) {
		let currentUrl = RouteHelper.getUrl(location.pathname, mutation, currency);
		if (location.pathname !== currentUrl) {
			return currentUrl;
		}
		return false;
	}

	/**
	 * Get mutation as route param, either for currently selected mutation, or for specified mutation
	 *
	 * If currency is defined, we have to always fill in the mutation
	 *
	 * @param {string?} mutation
	 * @param {?} currency
	 * @return {string}
	 */
	static getMutationAsRouteParam(mutation, currency) {
		if (!mutation) {
			mutation = MutationService.getMutation().code;
		}
		if (!currency) {
			currency = CurrencyService.getCurrency().getCodeForUrl();
		}
		if (currency) {
			if (currency === CurrencyService.getDefaultCurrency().getCodeForUrl() && mutation === MutationService.getDefaultMutation().code) {
				return '';
			}
			return mutation;
		}
		else if (!currency && mutation === MutationService.getDefaultMutation().code) {
			return '';
		}
		return mutation;
	}

	/**
	 * Get currency as route param, either for currently selected currency, or for specified currency
	 *
	 * @param {string?} currency
	 * @return {string}
	 */
	static getCurrencyAsRouteParam(currency) {
		if (!currency) {
			currency = CurrencyService.getCurrency().getCodeForUrl();
		}
		if (currency === CurrencyService.getDefaultCurrency().getCodeForUrl()) {
			return '';
		}
		return '-' + currency;
	}

	/**
	 * @return {string}
	 */
	static getBasePathWithMutationExpression() {
		return '/:mutationA(' + RouteHelper.getAllowedMutations() + ')';
	}

	/**
	 * @return {string}
	 */
	static getBasePathWithMutationAndCurrencyExpression() {
		return '/:mutationB(' + RouteHelper.getAllowedMutations() + ')-:currency(' + RouteHelper.getAllowedCurrencies() + ')';
	}

	/**
	 * @return {string}
	 */
	static getBasePathExpression() {
		return '';
	}

	/**
	 * @param {string} slugAndIdParam
	 *
	 * @return {{
			slug: ?string,
			id: ?string
		}}
	 */
	static parseSlugAndId(slugAndIdParam) {
		const result = {
			slug: null,
			id: null
		};

		// Extract url slug and id from the url ../adidas-100-X87FR8-0000000000000
		if (slugAndIdParam) {
			const slugAndIdMatch = slugAndIdParam.match(/^(.+)-([-_A-Za-z0-9]{20})$/);
			if (slugAndIdMatch === null || slugAndIdMatch.length !== 3) {
				return result;
			}
			result.slug = slugAndIdMatch[1];
			result.id = slugAndIdMatch[2];
		}

		return result;
	}
}





// WEBPACK FOOTER //
// ./helpers/RouteHelper.js